import { firebaseCloudFunctionService } from '@/libs/api';

export const COACH_ENDPOINTS = {
  SET_INACTIVE_FILTER: '/coach/inactiveFilterDefault/set',
} as const;

export const CoachServices = {
  setInactiveFilterDefault: async (request: { coachId: string; inactiveFilterLevel: number }) => {
    const response = await firebaseCloudFunctionService.get<void>(
      COACH_ENDPOINTS.SET_INACTIVE_FILTER,
      request,
    );
    return response;
  },
};
